function mapearGajos(gradosParada) {
    let valorGajo;
    if (gradosParada >= 0 && gradosParada < 15) {
        valorGajo = 100;
    } else if (gradosParada >= 15 && gradosParada < 30) {
        valorGajo = '1/2';
    } else if (gradosParada >= 30 && gradosParada < 45) {
        valorGajo = 'quiebra';
    } else if (gradosParada >= 45 && gradosParada < 60) {
        valorGajo = 25;
    } else if (gradosParada >= 60 && gradosParada < 75) {
        valorGajo = 0;
    } else if (gradosParada >= 75 && gradosParada < 90) {
        valorGajo = 50;
    } else if (gradosParada >= 90 && gradosParada < 105) {
        valorGajo = 75;
    } else if (gradosParada >= 105 && gradosParada < 120) {
        valorGajo = 200;
    } else if (gradosParada >= 120 && gradosParada < 135) {
        valorGajo = 'pierde turno';
    } else if (gradosParada >= 135 && gradosParada < 150) {
        valorGajo = 75;
    } else if (gradosParada >= 150 && gradosParada < 165) {
        valorGajo = 25;
    } else if (gradosParada >= 165 && gradosParada < 180) {
        valorGajo = 100;
    } else if (gradosParada >= 180 && gradosParada < 195) {
        valorGajo = 75;
    } else if (gradosParada >= 195 && gradosParada < 210) {
        valorGajo = 50;
    } else if (gradosParada >= 210 && gradosParada < 225) {
        valorGajo = 'quiebra';
    } else if (gradosParada >= 225 && gradosParada < 240) {
        valorGajo = 'x2';
    } else if (gradosParada >= 240 && gradosParada < 255) {
        valorGajo = 75;
    } else if (gradosParada >= 255 && gradosParada < 270) {
        valorGajo = 150;
    } else if (gradosParada >= 270 && gradosParada < 285) {
        valorGajo = 50;
    } else if (gradosParada >= 285 && gradosParada < 300) {
        valorGajo = 75;
    } else if (gradosParada >= 300 && gradosParada < 315) {
        valorGajo = 'pierde turno';
    } else if (gradosParada >= 315 && gradosParada < 330) {
        valorGajo = 150;
    } else if (gradosParada >= 330 && gradosParada < 345) {
        valorGajo = 75;
    } else if (gradosParada >= 345 && gradosParada < 360) {
        valorGajo = 50;
    }

    return valorGajo;

}

export default mapearGajos;
